module.exports = __webpack_public_path__ + "img/111026.b49b79ce.png";